import AssetDetailLayout from './AssetDetailLayout.container';

export default AssetDetailLayout;
